import {
  FileType,
  FileUploadStatus,
  IFile,
  IFileCardProps,
} from '@models/file';

export const addFileToDocumentWidgetFiles = (
  file: IFile,
  propertyId: string,
  entityTypeId: string,
  hideReviewedLabel = true,
  createdOn?: string,
  version?: number,
  documentCode = ''
) => {
  const newFile: IFileCardProps = {
    title: documentCode,
    status: FileUploadStatus.Uploaded,
    createdOn: createdOn,
    version: version,
    fileInfo: {
      id: file?.id,
      location: file?.location,
      path: file?.path,
      fileName: file?.fileName,
      length: file?.length,
      contentType: file?.contentType,
    },
    allowedFileTypes: [
      FileType.pdf,
      FileType.docx,
      FileType.jpeg,
      FileType.png,
    ],
    entityViewId: 'Production-download',
    propertyId: propertyId,
    entityId: file?.path?.split('/')[2],
    entityTypeId: entityTypeId,
    hideReviewedLabel: hideReviewedLabel,
  };

  return newFile;
};
